import { scrollY, scrollX, offsetBottom, elementHeight, animateScrollTop } from '@cian/ui/app/services/dom-utils';

export default ['$window', '$document', '$element', '$scope', 'analyticsService', 'navigationService', 'addFormService', 'geoService', function ($window, $document, $element, $scope, analyticsService, navigationService, addFormService, geoService) {
  this.handleClick = () => {
    animateScrollTop({
      to: 0,
      duration: 500,
      done: () => {

      },
    });
    this.clearAction();
    analyticsService.clearForm();
  };

  this.isSupportVisible = () => {
    const geoLocation = addFormService.ad.geo;
    const isNiNo = geoLocation &&
      geoLocation.userInput &&
      geoLocation.userInput.toLowerCase().includes('нижний новгород');

    return navigationService.links.length > 1 &&
      addFormService.ad.isByHomeowner &&
      (geoService.userGeo.id === 4596 || isNiNo);
  };

  const addFormNav = $element.parent()[0];
  const addFormNavLinks = $element[0].previousElementSibling;
  const bottomOffset = 25;
  const buttonComputePin = () => {
    const scrollLeft = addFormNav.getBoundingClientRect().left; // scrollbar width fix
    const scrollBottom = scrollY() + $document[0].documentElement.clientHeight;
    const isBottomPinned = (scrollBottom - bottomOffset) > offsetBottom(addFormNav);

    if ((scrollBottom - bottomOffset) > offsetBottom(addFormNavLinks) && !isBottomPinned) {
      $element.removeClass('state_bottom_pinned');
      $element.addClass('state_pinned');
      $element.css({ left: scrollLeft + 'px' }); // fiexd element horizontal scroll
    } else {
      $element.removeClass('state_pinned');
      $element.css({ left: 0 });
      if (isBottomPinned) {
        $element.addClass('state_bottom_pinned');
      } else {
        $element.removeClass('state_bottom_pinned');
      }
    }
  };
  $document.on('scroll', buttonComputePin);
  angular.element($window).on('resize', buttonComputePin);
  $scope.$watch(() => $document[0].getElementById('content').clientHeight, () => $scope.$applyAsync(buttonComputePin)); // в случае изменения высоты контента вызываем перерисовку
}];
